import { Controller } from '@hotwired/stimulus';
import { logAmplitudeEvent } from 'common/components/Amplitude/AmplitudeDataHelper';

// This is deprecated. Prefer `track_analytics_controller.js`. It uses the
// latest hotwire/stimulus dependency.

// Tracks analytics events to Amplitude
// If `browserEvent` is not defined, tracking will be called on `connect`.
//
// Ex:
// <div
//   data-controller="track-analytics"
//   data-track-analytics-browser-event-value="click"
//   data-track-analytics-name-value="Coaching Program Repurchase Button Clicked"
//   data-track-analytics-properties-value="{ ...payload... }"
// >
//   ...children...
// </div>

export default class extends Controller {
  static values = {
    browserEvent: String,
    name: String,
    properties: Object,
  };

  initialize() {
    this._track = this._track.bind(this);
  }

  connect() {
    if (this.hasBrowserEventValue) {
      this.element.addEventListener(this.browserEventValue, this._track);
    } else {
      this._track();
    }
  }

  disconnect() {
    if (this.hasBrowserEventValue) {
      this.element.removeEventListener(this.browserEventValue, this._track);
    }
  }

  _track() {
    logAmplitudeEvent({
      eventName: this.nameValue,
      eventProperties: this.propertiesValue,
      eventTransport: 'beacon',
    });
  }
}
